/*
 * Media queries utility
 */

/*
 * Inspired by https://github.com/DefinitelyTyped/DefinitelyTyped/issues/32914
 */

// Update your breakpoints if you want
export const sizes = {
  small: 600,
  medium: 1024,
  large: 1440,
  xlarge: 1920,
};

export const media = {
  small: `@media (max-width: ${sizes.small}px)`, // Applies up to 600px
  medium: `@media (min-width: ${sizes.small + 1}px) and (max-width: ${
    sizes.medium
  }px)`, // Applies from 601px to 1024px
  large: `@media (min-width: ${sizes.medium + 1}px) and (max-width: ${
    sizes.large
  }px)`, // Applies from 1025px to 1440px
  xlarge: `@media (min-width: ${sizes.large + 1}px)`, // Applies above 1440px
};
// export const sizes = {
//   small: 600,
//   medium: 1024,
//   large: 1440,
//   xlarge: 1920,
// };

// // Iterate through the sizes and create min-width media queries
// export const media = (Object.keys(sizes) as Array<keyof typeof sizes>).reduce(
//   (acc, size) => {
//     acc[size] = () => `@media (max-width:${sizes[size]}px)`;
//     return acc;
//   },
//   {} as { [key in keyof typeof sizes]: () => string },
// );

/* Example
const SomeDiv = styled.div`
  display: flex;
  ....
  ${media.medium} {
    display: block
  }
`;
*/
